var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_982_147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00021 0.720001C4.43156 0.720001 0.720215 4.43135 0.720215 9C0.720215 13.5687 4.43156 17.28 9.00021 17.28C13.5689 17.28 17.2802 13.5687 17.2802 9C17.2802 4.43135 13.5689 0.720001 9.00021 0.720001ZM9.00021 1.44C13.1798 1.44 16.5602 4.82046 16.5602 9C16.5602 13.1795 13.1798 16.56 9.00021 16.56C4.82068 16.56 1.44021 13.1795 1.44021 9C1.44021 4.82046 4.82068 1.44 9.00021 1.44ZM9.00021 3.96C8.71378 3.96 8.43908 4.07379 8.23654 4.27633C8.034 4.47886 7.92021 4.75357 7.92021 5.04C7.92021 5.32643 8.034 5.60114 8.23654 5.80368C8.43908 6.00622 8.71378 6.12 9.00021 6.12C9.28665 6.12 9.56135 6.00622 9.76389 5.80368C9.96643 5.60114 10.0802 5.32643 10.0802 5.04C10.0802 4.75357 9.96643 4.47886 9.76389 4.27633C9.56135 4.07379 9.28665 3.96 9.00021 3.96ZM7.56021 7.56V8.28H7.92021H8.28021V12.96H7.92021H7.56021V13.68H7.92021H8.28021H9.72021H10.0802H10.4402V12.96H10.0802H9.72021V7.56H9.36021H7.92021H7.56021Z",
    fill: "#0073B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_982_147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.dd803cd0c784fe02b848828c107a7990.svg";
export { ForwardRef as ReactComponent };